export default {
  'Cases types': 'GEHÄUSE-TYPEN',
  'Possible contents of the case': 'Möglicher Inhalt des Gehäuses',
  'Other cases': 'Andere Gehäuse',
  'Open for': 'Offen für',
};
